import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import '/src/static/css/dropdown.css'
import useInputDrop from '/src/ui/core/inputs/input_drop_hook'
import { ComboBox } from '@progress/kendo-react-dropdowns'
import { useWatch } from 'react-hook-form'
import { filterBy } from '@progress/kendo-data-query'

export default function InputConditionalCascadeDrop({ inputProps }) {
  const { options, dependency, filterAttribute, matchCondition, control, dataItem,
  textField } = inputProps

  const [dropOptions, setDropOptions] = useState(options)
  const [data, setData] = useState(options)
  const [disabled, setDisabled] = useState(false)
  const filterAttr = filterAttribute || dependency
  const { wrapperClass, inputClass, error, onFocus, onBlur,
          value, setValue, onComboChange, isOptionsString } = useInputDrop(inputProps)

  // TODO defaultValue stands for what is in the dataItem in the edit case
  const dependencyValue = useWatch({ control, name: dependency, defaultValue: undefined })

  useEffect(() => {
    const inCondition = matchCondition ? matchCondition.includes(dependencyValue) : true
    if (dependencyValue && inCondition) {
      const filteredOptions = options.filter((option) => option[filterAttr] === dependencyValue)
      setDisabled(false)
      setValue(null)
      setDropOptions(filteredOptions)
      setData(filteredOptions)
    } else {
      setDropOptions([])
      setData([])
      setValue(null)
      setDisabled(true)
    }
  }, [dependencyValue])

  const onFilterChange = (e) => setData(filterBy(dropOptions, e.filter))

  return (
    <div className={wrapperClass}>
      <ComboBox
        disabled={disabled}
        id={inputProps.id}
        className={inputClass()}
        data={data}
        value={value}
        onChange={onComboChange}
        onFocus={onFocus}
        onBlur={onBlur}
        popupSettings={{ className: 'combobox-list' }}
        filterable
        textField={isOptionsString() ? null : textField || 'description'}
        valueField={isOptionsString() ? null : 'id'}
        onFilterChange={onFilterChange}
        clearButton={false}
      />
      <div className="error-label">{error}</div>
    </div>
  )
}

InputConditionalCascadeDrop.propTypes = {
  inputProps: PropTypes.shape({
    id: PropTypes.string,
    className: PropTypes.string,
    title: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    required: PropTypes.oneOfType([
      PropTypes.bool, PropTypes.func
    ]),
    options: PropTypes.array,
    dependency: PropTypes.string,
    control: PropTypes.oneOfType([PropTypes.object]),
    dataItem: PropTypes.object
  }).isRequired
}
